import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../../app/store";
import { BotCode, BotType } from "../bot/types";
import {
  AppearanceType,
  IAiAppearance,
  ICloneAppearance,
  ITextScenarioAppearance,
  IVideoScenarioAppearance
} from "./types";

type initialStateType = {
  id: string;
  bot_code: BotCode | "";
  bot_type: BotType | "";
  title: string;
  configs: AppearanceType | null;
  originalData: AppearanceType | null;
  showModal: boolean;
  showVisibilityModal?: boolean;
};

type initialConfigType = {
  KITTY_02: IAiAppearance;
  KITTY_03: IAiAppearance;
  KITTY_04: IAiAppearance;
  MCBOT_01: ITextScenarioAppearance;
  VIDEO_SCENARIO: IVideoScenarioAppearance;
  CLONE_01: ICloneAppearance;
};

const initialConfig: initialConfigType = {
  KITTY_02: {
    name: {
      type: "auto",
      value: ""
    },
    icon: {
      type: "",
      value: ""
    },
    position: "right",
    isVoiceActive: true,
    logo: "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png",
    widget_poweredBy: true,
    show_initial_message: true,
    save_conversation: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    customPoweredBy: null,
    isFullScreen: false,
    isOpen: true,
    voiceResponse: false,
    assistantGender: "male",
    roundedVideo: true,
    workOnDesktop: true,
    alwaysShowButtons: true,
    operatingHours: {
      isActive: false,
      times: {
        sat: [],
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        exc: []
      },
      selectedTimezone: ""
    },
    notificationSound: "",
    notificationMessage: "",
    notificationBadge: false,
    isVisible: true,
    isNotificationMessageActive: false,
    isNotificationSoundActive: false,
    saveStats: false
  },
  KITTY_03: {
    name: {
      type: "auto",
      value: ""
    },
    icon: {
      type: "",
      value: ""
    },
    position: "right",
    isVoiceActive: true,
    logo: "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png",
    widget_poweredBy: true,
    show_initial_message: true,
    save_conversation: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    customPoweredBy: null,
    isFullScreen: false,
    isOpen: true,
    voiceResponse: false,
    assistantGender: "male",
    roundedVideo: true,
    workOnDesktop: true,
    alwaysShowButtons: true,
    operatingHours: {
      isActive: false,
      times: {
        sat: [],
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        exc: []
      },
      selectedTimezone: ""
    },
    notificationSound: "",
    notificationMessage: "",
    notificationBadge: false,
    isVisible: true,
    isNotificationMessageActive: false,
    isNotificationSoundActive: false,
    saveStats: false
  },
  KITTY_04: {
    name: {
      type: "auto",
      value: ""
    },
    icon: {
      type: "",
      value: ""
    },
    position: "right",
    isVoiceActive: true,
    logo: "",
    widget_poweredBy: true,
    show_initial_message: true,
    save_conversation: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    customPoweredBy: null,
    isFullScreen: false,
    isOpen: true,
    voiceResponse: false,
    assistantGender: "male",
    roundedVideo: true,
    workOnDesktop: true,
    alwaysShowButtons: true,
    operatingHours: {
      isActive: false,
      times: {
        sat: [],
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        exc: []
      },
      selectedTimezone: ""
    },
    notificationSound: "",
    notificationMessage: "",
    notificationBadge: false,
    isVisible: true,
    isNotificationMessageActive: false,
    isNotificationSoundActive: false,
    saveStats: false
  },
  MCBOT_01: {
    name: {
      type: "auto",
      value: ""
    },
    icon: {
      type: "",
      value: ""
    },
    position: "right",
    logo: "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png",
    widget_poweredBy: true,
    show_initial_message: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    customPoweredBy: null,
    isFullScreen: false,
    isOpen: true,
    roundedVideo: true,
    workOnDesktop: true,
    alwaysShowButtons: true,
    operatingHours: {
      isActive: false,
      times: {
        sat: [],
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        exc: []
      },
      selectedTimezone: ""
    },
    notificationSound: "",
    notificationBadge: false,
    isVisible: true,
    isNotificationMessageActive: false,
    isNotificationSoundActive: false,
    saveStats: false
  },
  VIDEO_SCENARIO: {
    name: {
      type: "auto",
      value: ""
    },
    icon: {
      type: "",
      value: ""
    },
    position: "right",
    logo: "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png",
    widget_poweredBy: true,
    show_initial_message: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    customPoweredBy: null,
    isFullScreen: false,
    isOpen: true,
    roundedVideo: true,
    workOnDesktop: true,
    alwaysShowButtons: true,
    operatingHours: {
      isActive: false,
      times: {
        sat: [],
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        exc: []
      },
      selectedTimezone: ""
    },
    notificationSound: "",
    notificationMessage: "",
    notificationBadge: false,
    isVisible: true,
    isNotificationMessageActive: false,
    isNotificationSoundActive: false,
    saveStats: false
  },
  CLONE_01: {
    name: {
      type: "auto",
      value: ""
    },
    logo: "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png",
    isVoiceActive: true,
    show_initial_message: true,
    theme: "light",
    color: "blue",
    poweredBy: true,
    voiceResponse: false
  }
};

const initialState: initialStateType = {
  id: "",
  bot_code: "",
  bot_type: "",
  title: "",
  configs: null,
  originalData: null,
  showModal: false
};

const appearanceSlice = createSlice({
  name: "appearance",
  initialState,
  reducers: {
    handleResetAppearance: () => initialState,

    handleToggleAppearanceModal: (state, action: PayloadAction<boolean>) => {
      state.showModal = action.payload;
    },

    handleInitializeEditAppearance: (
      state,
      action: PayloadAction<{
        id: string;
        bot_code: BotCode;
        bot_type: BotType;
        title: string;
        configs: AppearanceType;
        targetModal?: "appearance" | "visibility";
      }>
    ) => {
      state.id = action.payload.id;
      state.bot_code = action.payload.bot_code;
      state.bot_type = action.payload.bot_type;
      state.title = action.payload.title;
      state.configs = {
        ...action.payload.configs,
        logo:
          action.payload.configs.logo ??
          "https://cdn.1cdn.app/application/LOUISEBOT/2312171433313_Ellipse_980.png"
      };
      state.originalData = {
        ...action.payload.configs
      };
      state.showModal =
        !action.payload.targetModal ||
        (action.payload.targetModal &&
          action.payload.targetModal === "appearance")
          ? true
          : false;
      state.showVisibilityModal =
        action.payload.targetModal &&
        action.payload.targetModal === "visibility";
    },

    handleUpdateAppearanceItem: (
      state,
      action: PayloadAction<{
        key:
          | keyof ICloneAppearance
          | keyof IAiAppearance
          | keyof IVideoScenarioAppearance
          | keyof ITextScenarioAppearance;
        value: any;
      }>
    ) => {
      if (state.configs)
        state.configs = {
          ...state.configs,
          [action.payload.key]: action.payload.value
        };
    }
  }
  //   extraReducers(builder) {}
});

export const selectAppearanceState = (state: RootState) => state.appearance;

export const {
  handleResetAppearance,
  handleToggleAppearanceModal,
  handleInitializeEditAppearance,
  handleUpdateAppearanceItem
} = appearanceSlice.actions;

export default appearanceSlice.reducer;
